import { createSelector } from 'reselect';

import { getMainVideoId } from '@wix/wix-vod-shared/widget';
import { getVideosGroupedByIds } from './videos';

export const getMainVideo = createSelector(
  [getMainVideoId, getVideosGroupedByIds],
  (mainVideoId, videoByIds) => videoByIds[mainVideoId],
);
